import React from 'react';
// import { Input } from '@cokitchen/cokitchen-components';
import { EditAltIcon } from 'cokitchen-icons';
import { StreakType } from 'utils/types';

type Props = StreakType & {
  selected: boolean;
  hideEdit: boolean;
  onEditClick: () => void;
  onChange: (selected: boolean) => void;
};

const StreakCard = (props: Props) => {
  const { hideEdit, onEditClick, ...streak } = props;

  return (
    <div className='group flex items-center gap-2 px-6 py-3 rounded-lg shadow-[0px_6px_12px_0px_rgba(136,140,145,0.15)]'>
      {/* <Input type='checkbox' checked={selected} onChange={(e) => onChange?.(e.target.checked)} /> */}
      <article className='flex flex-col gap-[2px]'>
        <p className='text-[#2E3031] font-medium'>{streak.name}</p>
        <p className='text-sm text-[#6F7376] font-medium'>{streak.multiplier_effect_percentage}%</p>
      </article>

      {!hideEdit ? (
        <button
          className='w-6 h-6 flex items-center justify-center rounded-full border-[0.7px] border-[#EAEBEB] [&_path]:fill-[#A3A3A3] [&_svg]:w-[14px] [&_svg]:h-[14px] ml-auto opacity-0 group-hover:opacity-100'
          onClick={onEditClick}>
          <EditAltIcon />
        </button>
      ) : null}
    </div>
  );
};

export default StreakCard;
